import { useEffect, useRef } from "react";
import { HeroSection } from "@/components/report/HeroSection";
import { AnimatedStats } from "@/components/report/AnimatedStats";
import { CaseCards } from "@/components/report/CaseCards";
import { TrendCards } from "@/components/report/TrendCards";
import { QuoteSection } from "@/components/report/QuoteSection";
import { DataTable } from "@/components/report/DataTable";
import { DownloadForm } from "@/components/report/DownloadForm";
import { ContactSection } from "@/components/report/ContactSection";
import { EventBanner } from "@/components/report/EventBanner";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { SEO } from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";
import { homeJsonLd, articleJsonLd } from "@/lib/seo";


const Index = () => {
  const { t } = useLanguage();
  const downloadRef = useRef<HTMLDivElement>(null);

  const scrollToDownload = () => {
    downloadRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (typeof window === "undefined") return;
    const scrollToHash = () => {
      const hash = window.location.hash.replace("#", "");
      if (!hash) return;
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };
    // Retry a few times while sections mount/animate in
    const timers = [100, 400, 900, 1500].map((t) =>
      window.setTimeout(scrollToHash, t)
    );
    window.addEventListener("hashchange", scrollToHash);
    return () => {
      timers.forEach((id) => window.clearTimeout(id));
      window.removeEventListener("hashchange", scrollToHash);
    };
  }, []);


  const jsonLd = [
    ...homeJsonLd,
    ...articleJsonLd({
      headline: "4-Tage-Woche im Bankenwesen",
      description:
        "Whitepaper: Wie Banken mit der 4-Tage-Woche den Fachkräftemangel lösen.",
      path: "/",
      datePublished: "2026-01-15",
    }),
  ];


  return (
    <div className="min-h-screen bg-background">
      <SEO
        title={t.seo.home.title}
        description={t.seo.home.description}
        path="/"
        jsonLd={jsonLd}
      />
      <LanguageSwitcher />
      <HeroSection onDownloadClick={scrollToDownload} />
      <AnimatedStats />
      <CaseCards />
      <TrendCards />
      <QuoteSection />
      <EventBanner />
      <DataTable />
      <DownloadForm ref={downloadRef} />
      <ContactSection />
    </div>
  );
};

export default Index;
